import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Path from 'routes/Path';
import { FreecodeLoading } from 'components/FreecodePage/FreecodeLoading/FreecodeLoading';
import FreecodePage from 'components/FreecodePage/FreecodePage';
import { editorTypes } from 'components/FreecodePage/FreecodeLayout/FreecodeLayoutConstants';
import { useFreecodeContextLayout } from 'hooks/useContext';
import FreecodeLayout from 'components/FreecodePage/FreecodeLayout/FreecodeLayout';
import useTestInspectRunFunction from './useTestInspectRunFunction';
import useTestInspectLoadFunction from './useTestInspectLoadFunction';

export default function FreecodeTestInspect() {
  const { inputId } = useParams();

  const { setEditorType } = useFreecodeContextLayout();

  const { headerLinks, loading, error } = useTestInspectLoadFunction(inputId);
  useTestInspectRunFunction();

  useEffect(() => {
    setEditorType(editorTypes.freecodeInspect);
  }, [setEditorType]);

  return (
    <FreecodePage headerLinks={headerLinks}>
      <FreecodeLoading
        loading={loading}
        errors={[error]}
        errorLinkText="Go to home page"
        errorLink={Path.landingPage}
      />
      {!loading && <FreecodeLayout />}
    </FreecodePage>
  );
}
